import React from 'react'

import {ChangePaymentCardModal} from '../ChangePaymentCardModal/index@mobile'
import {PaymentCardButton} from '../PaymentCardButton'
import {usePaymentCard} from './hooks/usePaymentCard'
import type {PaymentCardProps} from './types'

export function PaymentCard(props: PaymentCardProps): React.ReactElement {
  const {baseProps, changePaymentCardModalProps} = usePaymentCard(props)

  return (
    <>
      <PaymentCardButton {...baseProps} />
      <ChangePaymentCardModal {...changePaymentCardModalProps} />
    </>
  )
}
